import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { WA_NUMBER, WA_MESSAGES } from '../constants'
import { treks } from '../data/treks'
import ContourMotif from './ContourMotif'

export default function Hero() {
  const [query, setQuery] = useState('')
  const navigate = useNavigate()

  const handleSearch = e => {
    e.preventDefault()
    const params = query.trim() ? `?q=${encodeURIComponent(query.trim())}` : ''
    navigate(`/${params}#treks`)
  }

  return (
    <section style={{
      height: '90vh',
      background: 'var(--green-dark)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      padding: '0 5%',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
        opacity: 0.1,
        backgroundImage: 'radial-gradient(circle at 50% 50%, var(--green-light) 0%, transparent 60%)'
      }} />
      {/* Subtle topographic underlay — barely-there map texture */}
      <ContourMotif stroke="rgba(255,255,255,0.9)" opacity={0.05} />

      <div style={{ textAlign: 'center', maxWidth: '800px', position: 'relative', zIndex: 1 }}>
        <div className="fade-up" style={{ fontSize: '12px', letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--green-mid)', fontWeight: 600, marginBottom: '24px' }}>
          Licensed Kathmandu Trekking Guide
        </div>
        <h1 className="fade-up-delay-1 serif" style={{ fontSize: 'clamp(42px, 8vw, 72px)', fontWeight: 600, lineHeight: 1.1, marginBottom: '24px' }}>
          Nepal as it used <br /> <span style={{ color: 'var(--green-mid)', fontStyle: 'italic' }}>to be.</span>
        </h1>
        <p className="fade-up-delay-2" style={{ fontSize: 'clamp(16px, 1.5vw, 19px)', color: 'rgba(255,255,255,0.7)', maxWidth: '580px', margin: '0 auto 40px', lineHeight: 1.6, fontWeight: 300 }}>
          Direct guidance, small groups, and restricted areas. Skip the agencies. Message me directly to start planning your 2025 adventure.
        </p>

        <form
          onSubmit={handleSearch}
          className="fade-up-delay-3"
          style={{
            display: 'flex', gap: '8px', maxWidth: '480px', margin: '0 auto 20px',
            background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.25)',
            borderRadius: '40px', padding: '6px', backdropFilter: 'blur(4px)',
          }}
        >
          <input
            type="text"
            value={query}
            onChange={e => setQuery(e.target.value)}
            placeholder="Search treks — Manaslu, Everest..."
            style={{
              flex: 1, minWidth: 0, background: 'transparent', border: 'none', outline: 'none',
              color: 'white', fontSize: '14px', padding: '10px 16px', fontFamily: 'var(--sans)',
            }}
          />
          <button type="submit" className="btn" style={{ padding: '10px 22px', background: 'var(--color-accent-cool)', color: 'var(--color-surface)' }}>
            Explore
          </button>
        </form>

        <div className="fade-up-delay-3" style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '40px' }}>
          {treks.map(t => (
            <Link
              key={t.id}
              to={`/${t.slug}`}
              className="badge"
              style={{ background: 'rgba(255,255,255,0.1)', color: 'white', borderColor: 'rgba(255,255,255,0.3)' }}
            >
              {t.name}
            </Link>
          ))}
        </div>

        <div className="fade-up-delay-3" style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <a
            href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGES.general)}`}
            target="_blank" rel="noreferrer"
            className="btn btn-primary"
            style={{ padding: '16px 32px', fontSize: '15px' }}
          >
            WhatsApp Me
          </a>
          <a
            href="#treks"
            className="btn btn-outline"
            style={{ padding: '16px 32px', fontSize: '15px' }}
          >
            View Treks
          </a>
        </div>
      </div>
    </section>
  )
}
